module.exports = __webpack_public_path__ + "img/画板 59.dd448cd2.svg";